import { render, staticRenderFns } from "./paginationWtxh.vue?vue&type=template&id=003c6f98&scoped=true"
import script from "./paginationWtxh.vue?vue&type=script&lang=js"
export * from "./paginationWtxh.vue?vue&type=script&lang=js"
import style0 from "./paginationWtxh.vue?vue&type=style&index=0&id=003c6f98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003c6f98",
  null
  
)

export default component.exports